module.exports = __webpack_public_path__ + "img/39_58.eadc8659.png";